import React from 'react';
import { generateLinkPath } from '@/utils/helper';
import useEditorStore from '@/store/useEditorStore';

export const D3Line = ({id, origX,origY, destX, destY, sc, hasStatus = false}) => {
    const selectedLine = useEditorStore.use.selectedLine();
    const setSelectedLine = useEditorStore.use.setSelectedLine();
    const d = generateLinkPath(origX,origY, destX, destY, sc, hasStatus);
    return (<g onClick={()=>{
        setSelectedLine(id);
    }} className={`red-ui-flow-link ${id == selectedLine?"red-ui-flow-link-selected":""}`}>
                <path className="red-ui-flow-link-background red-ui-flow-link-path" stroke={"#FFF"} strokeWidth={20} opacity={0} cursor={"crosshair"} fill='none' d={d}/>
                <path className="red-ui-flow-link-line red-ui-flow-link-path" stroke={"#FFF"} strokeWidth={5} strokeOpacity={0.4} fill='none' d={d}/>
                <path className="red-ui-flow-link-line red-ui-flow-link-path" stroke={"#999"} strokeWidth={3} fill='none' d={d}/>
            </g>);
}